// extracted by mini-css-extract-plugin
export default {"content":"loading-box_content__R1jas","loading_box":"loading-box_loading_box__TbbXB","loading":"loading-box_loading__61G78"};